export default __webpack_public_path__ + "static/media/pgmico(1).fc60a650.png";